import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to the top of the document on every route change so the
// new page always opens at its beginning (avoids the jump to previous
// scroll position kept between routes).
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    // If a hash is present (e.g. /#interior), let the hash-handler scroll to
    // that section instead of forcing the page to the top.
    if (hash) return;
    // Immediate jump — no animation, no visible re-scroll
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, hash]);
  return null;
}
